var map = {
	"./LBS1.webp": "77a9",
	"./chatduell1.webp": "3243",
	"./dealOrNoDeal.webp": "d3e2",
	"./jeopardy1.webp": "97b8",
	"./logo.png": "cf05",
	"./nexus.webp": "effa",
	"./quizpoker1.webp": "b334",
	"./wwm1.webp": "e4d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";